import PropTypes from 'prop-types';

export const SmtpAccountType = PropTypes.shape({
  id: PropTypes.number,
  clientId: PropTypes.string,
  clientSecret: PropTypes.string,
  status: PropTypes.number,
  clientProfileEmail: PropTypes.string,
  // Returned by API for SMTP connection status.
  isConnected: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
